import {
  AeropayLogoSecondary,
  GovernmentCircledIcon,
  Button,
  Flex,
  Link,
  Typography,
} from '@iheartjane/reefer';

interface SignedInWelcomeScreenProps {
  onLinkBankClick: () => void;
  storeHasJaneGold: boolean;
  storeHasWhiteLabel: boolean;
}

export const SignedInWelcomeScreen = ({
  onLinkBankClick,
  storeHasJaneGold,
  storeHasWhiteLabel,
}: SignedInWelcomeScreenProps) => {
  const subtext = storeHasWhiteLabel
    ? 'Link your bank account to shop faster at the kiosk.'
    : storeHasJaneGold
      ? 'Link your bank account to earn cash back with Jane Gold and shop faster with Jane Pay at the kiosk.'
      : 'Link your bank account to shop faster with Jane Pay at the kiosk.';

  return (
    <Flex
      flexDirection="column"
      height="100vh"
      width="100%"
      alignItems="center"
      justifyContent="center"
      px={24}
      gap={16}
    >
      <GovernmentCircledIcon size="xxl" color="primary" />
      <Typography branded textAlign="center" variant="h2-semibold">
        Link your bank account
      </Typography>
      <Typography textAlign="center">{subtext}</Typography>
      <Button
        full
        label="Link bank account"
        onClick={() => {
          onLinkBankClick();
        }}
        size="small"
      />
      <Flex flexDirection="column" gap={8}>
        <Typography textAlign="center">
          By agreeing to link your bank, you agree to Aeropay's{' '}
          <Link
            ariaLabel="link for Aeropay terms of service"
            href="https://www.aeropay.com/legal/terms-of-service"
            color="grays-mid"
          >
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link
            ariaLabel="link for Aeropay privacy policy"
            href="https://www.aeropay.com/legal/privacy-policy"
            color="grays-mid"
          >
            Privacy Policy
          </Link>
        </Typography>
        <Flex alignItems="center" justifyContent="center">
          <Typography>Powered by</Typography>
          <AeropayLogoSecondary height={15} />
        </Flex>
      </Flex>
    </Flex>
  );
};
